import React from 'react'
import ProfileCreated from "../../../../assets/images/child-profile-created.png";
import useLangTranslation from '../../../customHooks/languageProvider';
import { useHistory } from 'react-router-dom';
import { removeNewKidData } from '../../AxiosRtk/AddNewChild';
import { useDispatch } from 'react-redux';

const ChildProfileCreated = () => {
    const { getLangTranslation } = useLangTranslation();
    const history = useHistory();
    const dispatch = useDispatch();

    function handleGotItClicked() {
        dispatch(removeNewKidData());
        history.push("/dashboard");
    }


  return (
    <div className="card">
        <div className="card-body">
            <div className="content-400 mx-auto text-center">
                <div className="mb-9 mt-6">
                    <img src={ProfileCreated} alt='' />
                </div>
                <h5 className="mb-9">{getLangTranslation('CHILD_DEVICE_CREATED_SUCCESS_TEXT', 'The child`s profile was created successfully')}</h5>
                <div className="grid gap-3">
                    <button 
                        className="btn btn-primary g-col-12" 
                        type="button"
                        onClick={handleGotItClicked}
                    >
                        <span className="btn-upper-case" onClick={() => history.push("/dashboard")}>{getLangTranslation('SELECT_CHILD_GOT_IT', 'GOT IT')}</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
  )
}

export default ChildProfileCreated